/* BejModaXL — core theme behavior (vanilla JS, no build step required) */
(function () {
  "use strict";

  document.documentElement.classList.remove("no-js");

  function initScrollProgress() {
    var bar = document.querySelector("[data-scroll-progress]");
    if (!bar) return;
    var ticking = false;
    function update() {
      var h = document.documentElement;
      var scrollable = h.scrollHeight - h.clientHeight;
      var pct = scrollable > 0 ? (h.scrollTop / scrollable) * 100 : 0;
      bar.style.width = pct + "%";
      ticking = false;
    }
    document.addEventListener("scroll", function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  }

  function initHeader() {
    var header = document.querySelector("[data-site-header]");
    if (!header) return;
    var threshold = 40;
    function update() {
      if (window.scrollY > threshold) header.classList.add("is-scrolled");
      else header.classList.remove("is-scrolled");
    }
    document.addEventListener("scroll", update, { passive: true });
    update();
  }

  function initBackToTop() {
    var btn = document.querySelector("[data-back-to-top]");
    if (!btn) return;
    function toggle() {
      btn.classList.toggle("is-visible", window.scrollY > window.innerHeight * 0.8);
    }
    document.addEventListener("scroll", toggle, { passive: true });
    btn.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
    toggle();
  }

  function initAnimateOnScroll() {
    var els = document.querySelectorAll("[data-animate]");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  var lastFocused = null;
  function openDrawer(id) {
    var el = document.querySelector('[data-drawer="' + id + '"]');
    if (!el) return;
    lastFocused = document.activeElement;
    el.classList.add("is-open");
    el.setAttribute("aria-hidden", "false");
    document.body.classList.add("drawer-open-lock");
    var focusable = el.querySelector("button, [href], input, [tabindex]");
    if (focusable) focusable.focus();
  }
  function closeDrawer(id) {
    var el = document.querySelector('[data-drawer="' + id + '"]');
    if (!el) return;
    el.classList.remove("is-open");
    el.setAttribute("aria-hidden", "true");
    document.body.classList.remove("drawer-open-lock");
    if (lastFocused) lastFocused.focus();
  }
  function initDrawers() {
    document.addEventListener("click", function (e) {
      var openTrigger = e.target.closest("[data-drawer-open]");
      if (openTrigger) {
        e.preventDefault();
        openDrawer(openTrigger.getAttribute("data-drawer-open"));
        return;
      }
      var closeTrigger = e.target.closest("[data-drawer-close]");
      if (closeTrigger) {
        e.preventDefault();
        closeDrawer(closeTrigger.getAttribute("data-drawer-close"));
        return;
      }
      var overlay = e.target.closest("[data-drawer-overlay]");
      if (overlay) {
        closeDrawer(overlay.getAttribute("data-drawer-overlay"));
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        var openEl = document.querySelector(".drawer.is-open, .modal.is-open");
        if (openEl) closeDrawer(openEl.getAttribute("data-drawer"));
      }
    });
  }
  window.BejModaXL = window.BejModaXL || {};
  window.BejModaXL.openDrawer = openDrawer;
  window.BejModaXL.closeDrawer = closeDrawer;

  function initImageFade() {
    document.addEventListener("load", function (e) {
      if (e.target.tagName === "IMG") {
        e.target.classList.add("is-loaded");
      }
    }, true);
  }

  function initCardSwatches() {
    document.addEventListener("click", function (e) {
      var swatch = e.target.closest("[data-swatch]");
      if (!swatch) return;
      var card = swatch.closest("[data-product-card]");
      if (!card) return;
      card.querySelectorAll("[data-swatch]").forEach(function (s) { s.classList.remove("is-active"); });
      swatch.classList.add("is-active");
      var mainImg = card.querySelector("[data-main-image]");
      var newSrc = swatch.getAttribute("data-image");
      if (mainImg && newSrc) {
        mainImg.removeAttribute("srcset");
        mainImg.removeAttribute("sizes");
        mainImg.src = newSrc;
      }

      var productTitle = swatch.getAttribute("data-product-title");
      var productUrl = swatch.getAttribute("data-product-url");
      if (productUrl) {
        var mediaLink = card.querySelector(".product-card__image-link");
        var titleLink = card.querySelector(".product-card__title a");
        if (mediaLink) mediaLink.setAttribute("href", productUrl);
        if (titleLink) titleLink.setAttribute("href", productUrl);

        if (productTitle && titleLink) {
          titleLink.textContent = productTitle;
        }
        if (productTitle && mediaLink) {
          mediaLink.setAttribute("aria-label", productTitle);
        }
      }
      var variantId = swatch.getAttribute("data-variant-id");
      if (variantId) {
        var idInput = card.querySelector('[data-product-card-add-form] input[name="id"]');
        if (idInput) idInput.value = variantId;
      }

      var sizesAttr = swatch.getAttribute("data-sizes");
      var picker = card.querySelector("[data-size-picker]");
      if (sizesAttr && picker) {
        try {
          var sizes = JSON.parse(sizesAttr);
          picker.innerHTML = sizes.map(function (s) {
            return '<button type="button" data-size-option-btn data-variant-id="' +
              s.variantId + '"' + (s.available ? "" : " disabled") + ">" + s.size + "</button>";
          }).join("");
          if (productTitle) picker.setAttribute("data-product-title", productTitle);
          if (newSrc) picker.setAttribute("data-product-image", newSrc);
        } catch (err) {}
      }
    });
  }

  function escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str || "";
    return div.innerHTML;
  }

  function formatMoneyCents(cents) {
    try {
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "TRY";
      return new Intl.NumberFormat("tr-TR", { style: "currency", currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function updateCartCount() {
    fetch("/cart.js")
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-cart-count]").forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () {});
  }

  function refreshCartDrawer() {
    var url = window.location.pathname + (window.location.pathname.indexOf("?") > -1 ? "&" : "?") + "section_id=cart-drawer";
    return fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var freshDrawer = doc.querySelector('[data-drawer="cart"]');
        var currentDrawer = document.querySelector('[data-drawer="cart"]');
        if (!freshDrawer || !currentDrawer) return;
        var wasOpen = currentDrawer.classList.contains("is-open");
        currentDrawer.outerHTML = freshDrawer.outerHTML;
        if (wasOpen) {
          var updated = document.querySelector('[data-drawer="cart"]');
          if (updated) {
            updated.classList.add("is-open");
            updated.setAttribute("aria-hidden", "false");
          }
        }
      })
      .catch(function () {});
  }

  function showCartConfirmModal(item) {
    var modal = document.getElementById("CartConfirmModal");
    if (!modal || !item) return;
    var variantLabel = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";

    modal.innerHTML =
      '<div class="size-picker-modal__panel cart-confirm__panel">' +
        '<button type="button" class="size-picker-modal__close" data-cart-confirm-close aria-label="Kapat">&times;</button>' +
        '<div class="cart-confirm__check">✓</div>' +
        '<p class="cart-confirm__heading">Sepete Eklendi</p>' +
        '<div class="cart-confirm__product">' +
          (item.image ? '<img class="cart-confirm__image" src="' + item.image + '" alt="" width="84" height="112">' : "") +
          '<div class="cart-confirm__info">' +
            '<p class="cart-confirm__title">' + escapeHtml(item.product_title || "") + "</p>" +
            (variantLabel ? '<p class="cart-confirm__variant">' + escapeHtml(variantLabel) + "</p>" : "") +
            '<p class="cart-confirm__price">' + formatMoneyCents(item.final_price || item.price || 0) + "</p>" +
          "</div>" +
        "</div>" +
        '<div class="cart-confirm__actions">' +
          '<a href="/cart" class="btn btn-primary btn-block">Sepete Git</a>' +
          '<button type="button" class="btn btn-ghost btn-block" data-cart-confirm-close>Alışverişe Devam Et</button>' +
        "</div>" +
      "</div>";

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("drawer-open-lock");
    updateCartCount();
    refreshCartDrawer();
  }

  function closeCartConfirmModal() {
    var modal = document.getElementById("CartConfirmModal");
    if (!modal) return;
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("drawer-open-lock");
  }

  function initCartConfirm() {
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-cart-confirm-close]") || e.target.id === "CartConfirmModal") {
        closeCartConfirmModal();
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      var modal = document.getElementById("CartConfirmModal");
      if (modal && modal.classList.contains("is-open")) closeCartConfirmModal();
    });
  }

  window.BejModaXL = window.BejModaXL || {};
  window.BejModaXL.showCartConfirm = showCartConfirmModal;
  window.BejModaXL.updateCartCount = updateCartCount;
  window.BejModaXL.refreshCartDrawer = refreshCartDrawer;

  var sizePicker = { submitting: false };

  function openSizePickerModal(card) {
    var picker = card.querySelector("[data-size-picker]");
    var modal = document.getElementById("SizePickerModal");
    if (!picker || !modal) return;
    var title = picker.getAttribute("data-product-title") || "";
    var imageUrl = picker.getAttribute("data-product-image") || "";
    var buttonsHtml = Array.from(picker.querySelectorAll("[data-size-option-btn]")).map(function (b) {
      return '<button type="button" class="product-card__size-btn" data-modal-size-btn data-variant-id="' +
        b.getAttribute("data-variant-id") + '"' + (b.disabled ? " disabled" : "") + ">" + escapeHtml(b.textContent.trim()) + "</button>";
    }).join("");

    modal.innerHTML =
      '<div class="size-picker-modal__panel">' +
        '<button type="button" class="size-picker-modal__close" data-size-picker-close aria-label="Kapat">&times;</button>' +
        (imageUrl ? '<img class="size-picker-modal__image" src="' + imageUrl + '" alt="' + escapeHtml(title) + '" width="220" height="293">' : "") +
        (title ? '<p class="size-picker-modal__title">' + escapeHtml(title) + "</p>" : "") +
        '<p class="size-picker-modal__label">Beden Seçin</p>' +
        '<div class="size-picker-modal__grid">' + buttonsHtml + "</div>" +
        '<p class="size-picker-modal__status" data-size-picker-status></p>' +
      "</div>";

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("drawer-open-lock");
    sizePicker.submitting = false;
  }

  function closeSizePickerModal() {
    var modal = document.getElementById("SizePickerModal");
    if (!modal) return;
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("drawer-open-lock");
  }

  function submitSizeChoice(variantId, modal) {
    if (sizePicker.submitting || !variantId) return;
    sizePicker.submitting = true;
    var statusEl = modal.querySelector("[data-size-picker-status]");
    modal.querySelectorAll("[data-modal-size-btn]").forEach(function (b) { b.disabled = true; });
    if (statusEl) statusEl.textContent = "Ekleniyor…";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (data) { throw new Error(data.description || "add-failed"); });
        return res.json();
      })
      .then(function (item) {
        sizePicker.submitting = false;
        closeSizePickerModal();
        showCartConfirmModal(item);
      })
      .catch(function (err) {
        sizePicker.submitting = false;
        modal.querySelectorAll("[data-modal-size-btn]").forEach(function (b) { b.disabled = false; });
        if (statusEl) statusEl.textContent = (err && err.message) || "Bir hata oluştu, tekrar deneyin.";
      });
  }

  function initCardAddToCart() {
    document.addEventListener("click", function (e) {
      var needsSizeBtn = e.target.closest("[data-needs-size]");
      if (needsSizeBtn) {
        e.preventDefault();
        var card = needsSizeBtn.closest("[data-product-card]");
        if (card) openSizePickerModal(card);
        return;
      }

      var modalSizeBtn = e.target.closest("[data-modal-size-btn]");
      if (modalSizeBtn) {
        if (modalSizeBtn.disabled) return;
        var modal = document.getElementById("SizePickerModal");
        submitSizeChoice(modalSizeBtn.getAttribute("data-variant-id"), modal);
        return;
      }

      if (e.target.closest("[data-size-picker-close]") || e.target.id === "SizePickerModal") {
        closeSizePickerModal();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      var modal = document.getElementById("SizePickerModal");
      if (modal && modal.classList.contains("is-open")) closeSizePickerModal();
    });

    document.addEventListener("submit", function (e) {
      var form = e.target.closest("[data-product-card-add-form]");
      if (!form) return;
      var btn = form.querySelector('button[type="submit"]');
      if (!btn) return;
      if (btn.disabled) { e.preventDefault(); return; }
      btn.disabled = true;
    });
  }

  var WISHLIST_KEY = "bejmodaxl:wishlist";
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }
  function setWishlist(ids) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(ids));
    updateWishlistCount();
  }
  function updateWishlistCount() {
    var count = getWishlist().length;
    document.querySelectorAll("[data-wishlist-count-value]").forEach(function (el) {
      el.textContent = count;
    });
  }
  function syncWishlistButtons() {
    var ids = getWishlist().map(String);
    document.querySelectorAll("[data-wishlist-toggle]").forEach(function (btn) {
      var id = btn.getAttribute("data-product-id");
      btn.classList.toggle("is-active", ids.indexOf(id) !== -1);
    });
  }
  function initWishlist() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-wishlist-toggle]");
      if (!btn) return;
      var id = btn.getAttribute("data-product-id");
      var ids = getWishlist().map(String);
      var idx = ids.indexOf(id);
      if (idx === -1) ids.push(id); else ids.splice(idx, 1);
      setWishlist(ids);
      btn.classList.toggle("is-active", idx === -1);
    });
    syncWishlistButtons();
    updateWishlistCount();
  }
  window.BejModaXL = window.BejModaXL || {};
  window.BejModaXL.getWishlist = getWishlist;

  var SHIPMENT_CARRIER_NOTES = {
    yurtici: "Yurtiçi Kargo sayfası takip numaranızla otomatik açılacak.",
    mng: "MNG Kargo sayfasında takip numaranızı ve doğrulama kodunu tekrar girmeniz gerekecek."
  };
  function shipmentTrackingUrl(carrier, trackingNumber) {
    var code = encodeURIComponent(trackingNumber);
    if (carrier === "mng") {
      return "https://www.dhlecommerce.com.tr/gonderi-takip";
    }
    return "https://www.yurticikargo.com/tr/online-servisler/gonderi-sorgula?code=" + code;
  }
  function initShipmentTracking() {
    document.addEventListener("click", function (e) {
      var opener = e.target.closest("[data-open-shipment-tracking]");
      if (!opener) return;
      e.preventDefault();
      closeDrawer("mobile-menu");
      openDrawer("kargo-takip");
    });

    var form = document.querySelector("[data-shipment-tracking-form]");
    if (!form) return;
    var note = form.querySelector("[data-shipment-carrier-note]");
    function updateNote() {
      var carrier = form.querySelector('input[name="carrier"]:checked');
      if (note && carrier) note.textContent = SHIPMENT_CARRIER_NOTES[carrier.value] || "";
    }
    form.querySelectorAll('input[name="carrier"]').forEach(function (input) {
      input.addEventListener("change", updateNote);
    });
    updateNote();

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var carrier = form.querySelector('input[name="carrier"]:checked');
      var input = form.querySelector("#ShipmentTrackingNumber");
      var trackingNumber = input && input.value.trim();
      if (!trackingNumber) {
        if (input) input.focus();
        return;
      }
      var url = shipmentTrackingUrl(carrier ? carrier.value : "yurtici", trackingNumber);
      window.open(url, "_blank", "noopener");
    });
  }

  function initQuickView() {
    document.addEventListener("click", function (e) {
      var trigger = e.target.closest("[data-quick-view-open]");
      if (!trigger) return;
      var url = trigger.getAttribute("data-product-url");
      var modal = document.getElementById("QuickViewModal");
      if (!url || !modal) return;
      modal.innerHTML = '<div class="quick-view-modal__panel"><p class="text-muted">Yükleniyor…</p></div>';
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("drawer-open-lock");
      fetch(url + (url.indexOf("?") > -1 ? "&" : "?") + "section_id=quick-view")
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var content = doc.querySelector("[data-quick-view-content]");
          modal.innerHTML = '<div class="quick-view-modal__panel">' +
            '<button type="button" class="drawer__close quick-view-modal__close" data-quick-view-close aria-label="Kapat">' +
            '</button>' + (content ? content.outerHTML : "") + "</div>";
          var closeBtn = modal.querySelector("[data-quick-view-close]");
          if (closeBtn) closeBtn.innerHTML = document.querySelector("#IconCloseTemplate") ? "" : "&times;";
        })
        .catch(function () {
          modal.innerHTML = '<div class="quick-view-modal__panel"><p>Ürün yüklenemedi. <a href="' + url + '">Ürün sayfasına git</a></p></div>';
        });
    });

    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-quick-view-close]") || e.target.id === "QuickViewModal") {
        var modal = document.getElementById("QuickViewModal");
        modal.classList.remove("is-open");
        modal.setAttribute("aria-hidden", "true");
        document.body.classList.remove("drawer-open-lock");
      }
    });
  }

  function initCartRemove() {
    document.addEventListener("click", function (e) {
      var removeBtn = e.target.closest("[data-cart-remove]");
      if (!removeBtn) return;
      e.preventDefault();
      var key = removeBtn.getAttribute("data-cart-remove");
      var inDrawer = !!removeBtn.closest('[data-drawer="cart"]');

      if (inDrawer) {
        if (removeBtn.disabled) return;
        removeBtn.disabled = true;
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
          .then(function (res) { return res.json(); })
          .then(function () {
            updateCartCount();
            refreshCartDrawer();
          })
          .catch(function () { window.location.reload(); });
        return;
      }

      var input = document.querySelector('input[name="updates[' + key + ']"]');
      if (!input) return;
      input.value = 0;
      var form = input.closest("form");
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }

  if (!window.customElements.get("recommendations-products")) {
    class RecommendationsProducts extends HTMLElement {
      connectedCallback() {
        var url = this.dataset.url;
        if (!url) return;
        fetch(url)
          .then(function (res) { return res.text(); })
          .then(
            function (html) {
              var doc = new DOMParser().parseFromString(html, "text/html");
              var content = doc.querySelector("recommendations-products");
              if (content && content.innerHTML.trim().length) {
                this.innerHTML = content.innerHTML;
                initAnimateOnScroll();
              } else {
                this.remove();
              }
            }.bind(this)
          )
          .catch(function () {});
      }
    }
    window.customElements.define("recommendations-products", RecommendationsProducts);
  }

  function initPopupDiscount() {
    var popup = document.querySelector("[data-popup-discount]");
    if (!popup) return;

    var SEEN_KEY = "bejmodaxl:popup_seen";
    var skipPaths = ["/cart", "/checkout", "/account"];
    var path = window.location.pathname;
    if (skipPaths.some(function (p) { return path.indexOf(p) === 0; })) return;

    var alreadySeen = false;
    try { alreadySeen = !!localStorage.getItem(SEEN_KEY); } catch (e) {}
    if (alreadySeen) return;

    var shown = false;
    function markSeen() {
      try { localStorage.setItem(SEEN_KEY, "1"); } catch (e) {}
    }
    function showPopup() {
      if (shown) return;
      shown = true;
      popup.classList.add("is-open");
      popup.setAttribute("aria-hidden", "false");
    }
    function hidePopup() {
      popup.classList.remove("is-open");
      popup.setAttribute("aria-hidden", "true");
      markSeen();
    }

    var timer = setTimeout(showPopup, 12000);
    if (window.innerWidth >= 990) {
      document.addEventListener("mouseleave", function onLeave(e) {
        if (e.clientY <= 0) {
          clearTimeout(timer);
          showPopup();
          document.removeEventListener("mouseleave", onLeave);
        }
      });
    }

    popup.addEventListener("click", function (e) {
      if (e.target.closest("[data-popup-discount-close]") || e.target === popup) {
        hidePopup();
      }
    });

    function showPopupSuccess() {
      var body = popup.querySelector("[data-popup-discount-body]");
      if (!body) return;
      body.innerHTML =
        '<p class="popup-discount__eyebrow">Teşekkürler!</p>' +
        '<h2 class="popup-discount__title">Kodun Hazır</h2>' +
        '<p class="popup-discount__text">Aşağıdaki kodu ödeme sırasında girin, siparişinize %5 ekstra indirim uygulansın.</p>' +
        '<div class="popup-discount__code" data-popup-discount-code>EKSTRA5</div>' +
        '<button type="button" class="btn btn-primary btn-block" data-popup-discount-copy>Kodu Kopyala</button>';
      markSeen();
    }

    popup.addEventListener("submit", function (e) {
      var form = e.target.closest("#PopupDiscountForm");
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
      fetch(form.action, { method: "POST", body: new FormData(form) })
        .then(function () { showPopupSuccess(); })
        .catch(function () { showPopupSuccess(); });
    });

    popup.addEventListener("click", function (e) {
      var copyBtn = e.target.closest("[data-popup-discount-copy]");
      if (!copyBtn) return;
      var codeEl = popup.querySelector("[data-popup-discount-code]");
      var code = codeEl ? codeEl.textContent.trim() : "EKSTRA5";
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).then(function () {
          copyBtn.textContent = "Kopyalandı ✓";
        }).catch(function () {});
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initScrollProgress();
    initHeader();
    initBackToTop();
    initAnimateOnScroll();
    initDrawers();
    initImageFade();
    initCardSwatches();
    initCardAddToCart();
    initCartConfirm();
    initWishlist();
    initQuickView();
    initCartRemove();
    initShipmentTracking();
    initPopupDiscount();
  });
})();
